import {
  CircleGeometry,
  Color,
  Mesh,
  MeshStandardMaterial,
  Object3D,
  Vector3,
} from "three";
import { Context } from "../../../context";

export class ActorDisc extends Object3D {
  private mesh: Mesh;
  material: MeshStandardMaterial;

  constructor(context: Context) {
    super();

    const geo = new CircleGeometry(2, 32);
    this.material = new MeshStandardMaterial({
      color: new Color(context.state.actorSpotColor),
      transparent: true,
      opacity: 0,
    });

    geo.rotateX(-Math.PI / 2);

    this.mesh = new Mesh(geo, this.material);

    this.add(this.mesh);
    this.mesh.visible = true;
  }

  update(ground: Vector3, transAlpha: number, groundLevel: number) {
    const alpha = 1 - transAlpha;
    this.mesh.position.copy(ground).setY(groundLevel + 0.2);
    this.mesh.scale.set(alpha, 1, alpha);
    this.material.opacity = alpha;
    if (alpha == 0) {
      this.mesh.visible = false;
    } else if (!this.mesh.visible) {
      this.mesh.visible = true;
    }
  }
}
